module.exports = __webpack_public_path__ + "static/media/管道电伴热2.eacb07b2.jpg";